import Vue from 'vue'
import VueFlashMessage from '@/vue-flash-message';

Vue.use(VueFlashMessage)

